module.exports = __webpack_public_path__ + "rank-video-default-img-2ef04817.jpg";